<template>
    <LayoutSub className="training">
        <SubSection>
            <div class="title_wrap">
                <h2>
                    KICC는 <strong class="c-red">혁신적인 인재 양성</strong>을 통해 미래의 리더를 준비합니다.<br />
                    전문성과 창의성을 갖춘 인재들이 글로벌 무대에서<br />
                    활약할 수 있도록 최선을 다하고 있습니다.
                </h2>
            </div>
        </SubSection>
        <section class="section02" data-aos="fade-up">
            <div class="inner">
                <div class="content_area">
                    <div class="title_area">
                        <h2>인재양성</h2>
                        <p>
                            구성원 모두가 핵심인재로 성장하는 체계적인 역량강화 프로그램한국정보통신의 비전을 실현할 수 있는 인재양성을 목표로<br />
                            체계적인 교육 프로그램과 커리어관리계획을 수립하여 효과적으로 시행함으로써 한국정보통신이 추구하는 인재상에 적합한 인재 양성에 최선을 다하고 있습니다.
                        </p>
                    </div>
                    <div class="img_area">
                        <img src="@/assets/training_img01.png" alt="">
                    </div>
                </div>
            </div>
        </section>
        <section class="section03" data-aos="fade-up">
            <div class="inner">
                <div class="content_area">
                    <h2>인재상</h2>
                    <ul class="img_list">
                        <li class="img_item">
                            <div class="img_box">
                                <img src="@/assets/training_img02.png" alt="">
                                <div class="add_img">
                                    <img src="@/assets/training_hover_img.png" alt="">
                                </div>
                                <div class="hover_content">
                                    <p class="sub_title">P.L</p>
                                    <h3 class="main_title">Performance Leader</h3>
                                    <div class="icon_box">
                                        <img src="@/assets/training_icon.png" alt="">
                                    </div>
                                    <p class="txt">도전적인 목표의식과 기업가적인 추진력으로<br>가치있는 성과를 주도적으로 창출하는 인재</p>
                                </div>
                            </div>
                            <h2 class="title">Performance Leader</h2>
                        </li>
                        <li class="img_item">
                            <div class="img_box">
                                <img src="@/assets/training_img03.png" alt="">
                                <div class="add_img">
                                    <img src="@/assets/training_hover_img.png" alt="">
                                </div>
                                <div class="hover_content">
                                    <p class="sub_title">C.C</p>
                                    <h3 class="main_title">Change Creator</h3>
                                    <div class="icon_box">
                                        <img src="@/assets/training_icon2.png" alt="">
                                    </div>
                                    <p class="txt">급변하는 경영환경 속에서 끊임없는 자기혁신과<br>창의력으로 변화를 창조하는 인재</p>
                                </div>
                            </div>
                            <h2 class="title">Change Creator</h2>
                        </li>
                        <li class="img_item">
                            <div class="img_box">
                                <img src="@/assets/training_img04.png" alt="">
                                <div class="add_img">
                                    <img src="@/assets/training_hover_img.png" alt="">
                                </div>
                                <div class="hover_content">
                                    <p class="sub_title">P.D</p>
                                    <h3 class="main_title">Professional Developer</h3>
                                    <div class="icon_box">
                                        <img src="@/assets/training_icon3.png" alt="">
                                    </div>
                                    <p class="txt">철저한 프로정신과 부단한 자기계발로<br>자신의 분야의 최고 전문가가 되는 인재</p>
                                </div>
                            </div>
                            <h2 class="title">Professional Developer</h2>
                        </li>
                    </ul>
                </div>
            </div>
        </section>
        <section class="section04" data-aos="fade-up">
            <div class="inner">
                <div class="content_area">
                    <h2>교육내용</h2>
                    <div class="row">
                        <div class="left_area">
                            <ul>
                                <li @click="changeContent('unit')" :class="activeContent === 'unit' ? 'selected' : ''">
                                    학점이수제 실시</li>
                                <li @click="changeContent('edu')" :class="activeContent === 'edu' ? 'selected' : ''">법정
                                    의무 교육 과정 외</li>
                            </ul>
                        </div>
                        <div class="right_area">
                            <section v-if="activeContent === 'unit'">
                                <div class="content">
                                    <div class="title_wrap">
                                        <h3>학점이수제 실시</h3>
                                        <p>한국정보통신은 직원의 능력개발과 조직의 업무 수행능력 향상을 위해 연간 이수해야 할 개인별 학점을 설정하고, 각 학습자가 회사가 제시한
                                            교육 범위 내에서 스스로 선택하고 이수토록 하여 자기 개발을 할 수 있도록 지원하고 있습니다.</p>
                                    </div>
                                    <table class="tbl">
                                        <colgroup>
                                            <col width="30%">
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>학점이수제 대상과정</th>
                                                <th>교육내용</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>직급별 집체 교육</td>
                                                <td>직급별 공통 소양 함양 및 트렌드 학습을 위한 과정</td>
                                            </tr>
                                            <tr>
                                                <td>온라인 역량개발과정</td>
                                                <td>온라인(PC/모바일) 환경에서 실시하는 역량 개발 과정</td>
                                            </tr>
                                            <tr>
                                                <td>오프라인 역량개발과정</td>
                                                <td>오프라인(집체/대면) 환경에서 실시하는 역량 개발 과정</td>
                                            </tr>
                                            <tr>
                                                <td>부서별 직무 교육</td>
                                                <td>각 부서별 실시하는 직무 교육</td>
                                            </tr>
                                            <tr>
                                                <td>어학 교육</td>
                                                <td>인정 기간 동안 취득한 어학 시험 성적에 따른 학점 부여</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </section>
                            <section v-if="activeContent === 'edu'">
                                <div class="content">
                                    <div class="title_wrap">
                                        <h3>법정 의무 교육 과정 외</h3>
                                        <p>한국정보통신은 법정 의무 교육을 통해 관련 법규 준수 및 취지를 이행하고 있으며 신규 입사자의 회사 적응을 지원하고 사내 지식 공유를 통한
                                            건전한 기업문화를 지향하고 있습니다.</p>
                                    </div>
                                    <table class="tbl">
                                        <colgroup>
                                            <col width="30%">
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>구분</th>
                                                <th>교육내용</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>법정 의무 교육</td>
                                                <td>성희롱/직장 내 괴롭힘 예방 교육, 장애인인식개선교육, 윤리경영 교육, 정보보안 교육 등</td>
                                            </tr>
                                            <tr>
                                                <td>신규 입사자 교육</td>
                                                <td>신입(인턴) 및 경력 입사자 대상 회사 적응 및 부서별 직무 소개를 위한 교육</td>
                                            </tr>
                                            <tr>
                                                <td>사내 교육 과정</td>
                                                <td>사내에서 지식 및 노하우를 공유하고 활용하여 함께 성장할 수 있는 기회 제공</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </LayoutSub>
</template>
<script>
import SubSection from '@/components/SubSection.vue';
import LayoutSub from '@/layouts/LayoutSub.vue';

export default {
    components: {
        LayoutSub,
        SubSection
    },
    data() {
        return {
            activeContent: 'unit',
        }
    },
    methods: {
        changeContent(content) {
            this.activeContent = content;
        }
    }
}
</script>